const AquariumIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      d="M21 0V3C20.9963 6.18143 19.731 9.23181 17.4814 11.4814C15.2318 13.731 12.1813 14.9963 9 15H7.5V20.25C7.4999 20.3983 7.45539 20.5437 7.37298 20.667C7.29066 20.79 7.17373 20.8857 7.03704 20.9424C6.90002 20.9991 6.74891 21.0143 6.60345 20.9854C6.45803 20.9564 6.32453 20.8851 6.21966 20.7803L0.219657 14.7803C0.114863 14.6754 0.0435381 14.5418 0.0145787 14.3965C-0.014345 14.251 -0.000171814 14.0999 0.0565709 13.9629C0.113323 13.8259 0.209631 13.7084 0.332938 13.626C0.456223 13.5436 0.601659 13.5 0.74993 13.5H6V12C6.00356 8.81852 7.26884 5.7682 9.51848 3.51855C11.7681 1.26898 14.8185 0.00363253 18 0H21ZM2.56048 15L6 18.4395V15H2.56048ZM10.4306 4.74219C8.5507 6.69073 7.50013 9.29244 7.5 12V13.5H9C11.7074 13.4997 14.3092 12.4491 16.2577 10.5693L10.4306 4.74219ZM18 1.5C15.6588 1.50006 13.3857 2.28758 11.5458 3.73535L17.2646 9.4541C18.7123 7.61428 19.5 5.34115 19.5 3V1.5H18ZM16.499 3C16.9132 3 17.249 3.33579 17.249 3.75C17.249 4.16421 16.9132 4.5 16.499 4.5C16.0849 4.49977 15.749 4.16407 15.749 3.75C15.749 3.33593 16.0849 3.00023 16.499 3Z"
      fill="currentColor"
    />
  </svg>
);

export default AquariumIcon;
